<template>
<div>
    <div class="d-flex align-items-center justify-content-between">
        <a :href="routeBack" style="color:#111827; border-color:#848486;" class="btn btn-secondary">
            <i class="fe fe-chevron-left mr-1"></i>
            {{ trans['Kembali'] }}
        </a>
        <div v-if="false">
            <div class="form-check">
                <input type="checkbox" class="form-check-input" v-model="isMultiLanguage">
                <span class="form-check-label">Dwibahasa</span>
            </div>
        </div>
    </div>
    <h4 class="my-5" style="color:#111827">{{ trans['Butiran Berita'] }}</h4>
    <div class="card mt-4">
        <div class="card-body">
            <div class="row">
                <div v-if="singleColumn" class="col-12">
                    <div class="form-group">
                        <div style="color:#111827;" class="form-label">{{ trans['Tajuk'] }} <span class="text-red">*</span></div>
                        <input type="text" class="form-control" :name="`title[${lang}]`" dusk="title-input" id="title" placeholder="News Title" v-model="post.title[lang]">
                    </div>

                    <span v-if="initPost && initPost.id" class="text-muted d-flex align-items-start">
                        <span>URL:</span>
                        <a target="_blank" style="margin-top: -0.1rem !important;" class="btn btn-link pl-2 pb-4 pt-0 text-left" :href="`/${lang}/berita/${post.slug.ms}`">{{ `${appUrl}/${lang}/berita/${post.slug[lang]}` }}
                            <i class="fa fa-external-link"></i>
                        </a>
                        <small>This post link can only be used after published.</small>
                    </span>

                    <!-- <div v-if="initPost && initPost.id" class="form-group">
                        <div class="form-label">Publish Date <span class="text-red">*</span></div>
                        <input type="date" class="form-control" name="published_at" id="published_at" v-model="post.published_at"></input>
                    </div> -->

                    <div class="form-group">
                        <div style="color: #111827" class="form-label">{{ trans['Penerangan Kandungan'] }} <span class="text-red">*</span></div>
                        <!-- <editor
                            api-key="ld33zdqw1j584sq2xzacd6z5uk91buqq8fgcbo99fscraepd"
                            :name="`content[${lang}]`"
                            :init="{
                                height: 600,
                                plugins: [
                                'emoticons',
                                'link',
                                'media'
                                ],
                                media_live_embeds: true
                            }"
                            v-model="post.content[lang]"
                            required="true"
                        /> -->
                        <quill-editor v-model="post.content[lang]"
                            class="mb-3"
                            id="rich-text"
                            rows="20"
                            :options="editorOption"
                            ref="myQuillEditor"
                            @blur="onEditorBlur($event)"
                            @focus="onEditorFocus($event)"
                            @ready="onEditorReady($event)">
                        </quill-editor>
                        <span v-if="errors[`content.${lang}`] && errors[`content.${lang}`][0]" class="text-danger text-sm">{{ errors[`content.${lang}`][0] }}</span>
                        <p v-if="lang != 'ms'" class="text-sm text-muted pl-3 pt-1" v-html="post.content.ms"></p>
                    </div>

                    <div class="form-group col-3 pl-0" v-if="currentRoleUser == 'admin'">
                        <div style="color: #111827" class="form-label">{{ trans['Status'] }}</div>
                        <select  class="custom-select" style="color: #111827;" name="publish_status" id="publish_status" v-model="publishStatus">
                            <option value="" disabled>Select Status</option>
                            <option value="draft">Draft</option>
                            <option value="published">Published</option>
                        </select>
                    </div>

                    <div class="form-group col-4 pl-0" v-else>
                        <input class="form-control" type="hidden" name="publish_status" id="publish_status" v-model="publishStatus">
                        <input class="form-control" type="hidden" name="institution_id" id="institution_id" v-model="post.institution_id">
                    </div>

                    <div class="form-group">
                        <div style="color: #111827" class="form-label">{{ trans['Muat Naik Gambar'] }} <span class="text-red">*</span>
                        </div>
                        <div class="container w-50 mx-0 p-4 border rounded">
                            <div class="row">
                                <div class="col-md-12">
                                    <!-- image preview -->
                                    <div class="d-flex justify-content-center align-items-center w-75">
                                        <img v-if="previewImageUrl" :src="previewImageUrl" class="mb-2 rounded"/>
                                    </div>

                                    <div class="d-flex align-items-center mb-2">
                                        <div class="custom-file" style="width:100%" v-if="lang == 'ms'">
                                            <input id="image_ms" class="custom-file-input" type="file" name="image_ms" ref="image_ms" @change="handleFileUpload()">
                                            <label class="custom-file-label" for="image_ms">Choose file</label>
                                        </div>
                                        <div class="custom-file" style="width:30%" v-if="lang == 'en'">
                                            <input id="image_en" class="custom-file-input" type="file" name="image_en" ref="image_en" @change="handleFileUpload()">
                                            <label class="custom-file-label" for="image_en">Choose file</label>
                                        </div>
                                        <p class="mb-0 ml-2">{{ images[lang] ? images[lang].name : '' }}</p>
                                    </div>
                                    <div v-if="mode == 'edit' && getPostImageUrl()">
                                        <img :src="getPostImageUrl()" class="img-thumbnail mb-2" style="height: 200px; width: auto;">
                                    </div>
                                    <div v-if="post.imageUrls.images && post.imageUrls['images'] && !post.imageUrls[`images-${lang}`]">
                                        <img :src="post.imageUrls.images" class="img-thumbnail mb-2" style="height: 200px; width: auto;">
                                        <p class="text-danger">
                                            Default poster is already available. Translation poster is required
                                        </p>
                                    </div>

                                    <div class="p-2" style="color:#111827;">
                                        <p class="mb-1">PNG, JPEG, JPG: 50MB file limit</p>
                                        <p class="mb-1">At least 800x600 pixels</p>
                                        <p class="mb-1">4:3 aspect ratio</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="pt-4" style="color: #111827;">
                            <b style="font-size:14px;">Pro Tip :</b>
                            <ul class="mb-6">
                                <li class="mb-1">Less word image is encouraged.</li>
                                <li class="mb-1">Keep it simple and word in the center.</li>
                                <li class="mb-1">Please ensure the image is emotionally engaging.</li>
                            </ul>
                        </div>
                    </div>

                    <div class="d-flex justify-content-start">
                        <button v-if="mode == 'add'" type="button" id="add-post" style="color:#111827; padding: 8px 16px; background-color:#4CAF50; border:#4CAF50; opacity:1;" @click="submit()" class="btn btn-primary" :disabled="!getFormValidity() || isUpdating">{{ trans['Simpan Berita'] }}</button>
                        <button v-else type="button" id="update-post" @click="submit()" style="color:#111827; padding: 8px 16px; background-color:#4CAF50; border:#4CAF50; opacity:1;" class="btn btn-primary" :disabled="!getFormValidity() || isUpdating">{{ trans['simpan'] }}</button>
                        <moon-loader class="ml-2" :loading="isUpdating" id="spinner" :color="'#26A65B'" :size="'36px'"></moon-loader>
                    </div>
                </div>

                <div v-else class="col-9">
                    <div class="form-group">
                        <div class="form-label">Title <span class="text-red">*</span></div>
                        <input type="text" class="form-control" :name="`title[${lang}]`" dusk="title-input" id="title" placeholder="Majlis Amal Aman palestin" v-model="post.title[lang]">
                    </div>

                    <span v-if="initPost && initPost.id" class="text-muted d-flex align-items-start"><span>URL:</span> <a target="_blank" style="margin-top: -0.1rem !important;" class="btn btn-link pl-2 pb-2 pt-0 text-left" :href="`/${lang}/berita/${post.slug.ms}`">{{ `${appUrl}/${lang}/berita/${post.slug[lang]}` }} <i class="fa fa-external-link"></i></a></span>

                    <div v-if="initPost && initPost.id" class="form-group">
                        <div class="form-label">Publish Date <span class="text-red">*</span></div>
                        <input type="date" class="form-control" name="published_at" id="published_at" v-model="post.published_at"></input>
                    </div>

                    <div class="form-group">
                        <div class="form-label">Content <span class="text-red">*</span></div>
                        <!-- <editor
                            api-key="ld33zdqw1j584sq2xzacd6z5uk91buqq8fgcbo99fscraepd"
                            :name="`content[${lang}]`"
                            :init="{
                                height: 600,
                                plugins: [
                                'emoticons',
                                'link',
                                'media'
                                ],
                                media_live_embeds: true
                            }"
                            v-model="post.content[lang]"
                            required="true"
                        /> -->
                        <span v-if="errors[`content.${lang}`] && errors[`content.${lang}`][0]" class="text-danger text-sm">{{ errors[`content.${lang}`][0] }}</span>
                        <p v-if="lang != 'ms'" class="text-sm text-muted pl-3 pt-1" v-html="post.content.ms"></p>
                    </div>

                    <div class="form-group col-3 pl-0" v-if="currentRoleUser == 'admin'">
                        <div class="form-label">{{ trans['Status'] }}</div>
                        <select style="color: #111827;" class="custom-select" name="publish_status" id="publish_status" v-model="publishStatus">
                            <option value="" disabled>Select Status</option>
                            <option value="draft">Draft</option>
                            <option value="published">Published</option>
                        </select>
                    </div>
                    <div class="form-group col-4 pl-0" v-else>
                        <input class="form-control" type="hidden" name="publish_status" id="publish_status" v-model="publishStatus">
                        <input class="form-control" type="hidden" name="institution_id" id="institution_id" v-model="post.institution_id">
                    </div>

                    <div class="form-group">
                        <div class="form-label">Post Image <span class="text-red">*</span></div>
                        <div class="d-flex align-items-center mb-2">
                            <div class="custom-file" style="width:30%" v-if="lang == 'ms'">
                                <input id="image_ms" class="custom-file-input" type="file" name="image_ms" ref="image_ms" @change="handleFileUpload()">
                                <label class="custom-file-label" for="image_ms">Choose file</label>
                            </div>
                            <div class="custom-file" style="width:30%" v-if="lang == 'en'">
                                <input id="image_en" class="custom-file-input" type="file" name="image_en" ref="image_en" @change="handleFileUpload()">
                                <label class="custom-file-label" for="image_en">Choose file</label>
                            </div>
                            <p class="mb-0 ml-2">{{ images[lang] ? images[lang].name : '' }}</p>
                        </div>
                        <div v-if="mode == 'edit' && getPostImageUrl()">
                            <img :src="getPostImageUrl()" class="img-thumbnail mb-2" style="height: 200px; width: auto;">
                        </div>
                        <div v-if="post.imageUrls.images && post.imageUrls['images'] && !post.imageUrls[`images-${lang}`]">
                            <img :src="post.imageUrls.images" class="img-thumbnail mb-2" style="height: 200px; width: auto;">
                            <p class="text-danger">
                                Default poster is already available. Translation poster is required
                            </p>
                        </div>
                    </div>

                    <div class="d-flex justify-content-start">
                        <button v-if="mode == 'add'" type="button" id="add-post" @click="submit()" style="color:#111827; padding: 8px 16px; background-color:#4CAF50; border:#4CAF50; opacity:1;" class="btn btn-primary" :disabled="!getFormValidity() || isUpdating">Add Post</button>
                        <button v-else type="button" id="update-post" @click="submit()" style="color:#111827; padding: 8px 16px; background-color:#4CAF50; border:#4CAF50; opacity:1;" class="btn btn-primary" :disabled="!getFormValidity() || isUpdating">Update Post</button>
                        <moon-loader class="ml-2" :loading="isUpdating" id="spinner" :color="'#26A65B'" :size="'36px'"></moon-loader>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<style>
    .post-language-button.content-valid::after {
        background-color: #1d9f3c;
    }
    .post-language-button:not(.content-valid) {
        color: #cd201f !important;
    }
    .post-language-button {
        padding-left: 1.5rem !important;
    }
    .post-language-button::after {
        content: "";
        position: absolute;
        border-radius: 50%;
        height: 7px;
        width: 7px;
        background-color: #cd201f;
        left: 1px;
        top: 55%;
        margin-top: -4px;
    }
    .post-toast {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !default;
        color: white;
        background-color: #5eba00 !important;
    }
    .dont-break-out {
        /* These are technically the same, but use both */
        overflow-wrap: break-word;
        word-wrap: break-word;

        -ms-word-break: break-all;
        /* This is the dangerous one in WebKit, as it breaks things wherever */
        word-break: break-all;
        /* Instead use this non-standard one: */
        word-break: break-word;

        /* Adds a hyphen where the word breaks, if supported (No Blink) */
        -ms-hyphens: auto;
        -moz-hyphens: auto;
        -webkit-hyphens: auto;
        hyphens: auto;
    }
</style>

<script>
    import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min';
    import Editor from '@tinymce/tinymce-vue';
    // Import Quill required dependencies
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import { quillEditor, Quill } from 'vue-quill-editor'
    import ImageResize from 'quill-image-resize';

    // Register ImageResize module
    Quill.register('modules/imageResize', ImageResize);

    // Set toolbar options
    const toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],

        [{'header': 1}, {'header': 2}],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'script': 'sub'}, {'script': 'super'}],
        [{'indent': '-1'}, {'indent': '+1'}],
        [{'direction': 'rtl'}],

        [{'size': ['small', false, 'large', 'huge']}],
        [{'header': [1, 2, 3, 4, 5, 6, false]}],

        [{'color': []}, {'background': []}],
        [{'font': []}],
        [{'align': []}],
        ['link', 'image', 'video'],
        ['clean'],
    ];

    export default {
        data() {
            return {
                lang: this.initLang,
                post: {
                    title: {
                        'en': '',
                        'ms': ''
                    },
                    slug: {
                        'en': '',
                        'ms': ''
                    },
                    content: {
                        'en': '',
                        'ms': ''
                    },
                    imageUrls: [],
                    institution_id: this.institution
                },
                publishStatus: this.initPost && this.initPost.published_at ? 'published' : this.initPost ? 'draft' : '',

                images: {
                    ms: '',
                    en: ''
                },
                images: {
                    ms: '',
                    en: ''
                },
                errors: {},
                isUpdating: false,
                isMultiLanguage: this.isNotMultiTenant,
                previewImageUrl: null
            };
        },
        components: {
            MoonLoader,
            quillEditor,
            'editor': Editor
        },
        props: {
            routeBack: {},
            route: {},
            csrf: {},
            appUrl: {},
            trans: {},
            initLang: {},
            mode: {},
            initPost: {
                default: function() {
                    return null;
                },
            },
            currentRoleUser: {},
            institution: {},
            isNotMultiTenant: {
                default: true
            },
            singleColumn: {
                default: false
            }
        },
        computed: {
            editor(){
                return this.$refs.myQuillEditor.quill
            }
        },
        methods: {
            handleFileUpload() {
                this.images[this.lang] = this.$refs[`image_${this.lang}`].files[0];

                //create image preview
                const file = this.$refs[`image_${this.lang}`].files[0];
                this.previewImageUrl = URL.createObjectURL(file);
                URL.revokeObjectURL(file);
            },
            submit() {
                this.isUpdating = true;
                let data = new FormData();

                if (this.images['ms']) {
                    data.append('image_ms', this.images['ms']);
                }

                if (this.images['en']) {
                    data.append('image_en', this.images['en']);
                }

                if (this.mode == 'edit') {
                    data.append('_method', 'PUT');
                }

                data.append('publish_status', this.publishStatus);
                
                data.append('is_multi_language', this.isMultiLanguage);

                Object.keys(this.post).forEach(key => {
                    let input = 
                        ['title', 'slug', 'content', 'media'].includes(key)
                            ? JSON.stringify(this.post[key])
                            : this.post[key];

                    data.append(key, input);

                    if (key == 'published_at' && this.post.published_at == null)
                        data.append(key, []);
                    if (key == 'institution_id' && this.post.institution_id == null)
                        data.append(key, []);
                });

                // for (var pair of data.entries()) {
                //     console.log(pair[0]+ ', ' + pair[1]); 
                // }

                axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
                axios.post(
                    this.route,
                    data
                ).then((response) => {
                    this.$toasted.show(`Post ${this.mode == 'add' ? 'added' : 'updated'}`, { 
                        theme: "toasted-primary", 
                        position: "bottom-right", 
                        duration : 20000,
                        icon: {name: 'check'},
                        className: ['post-toast', 'font-weight-bold']
                    });

                    this.resetData(response.data);

                    if (this.mode == 'add') {
                        window.location.href = this.routeBack;
                    } else {
                        window.scrollTo({
                            top: 0,
                            behavior: 'smooth'
                        });
                    }
                    this.isUpdating = false;
                }).catch((error) => {
                    console.log(error);
                    console.log(error.response);
                    window.scrollTo(0,0);
                    this.errors = _.get(error, 'response.data.errors');
                    this.isUpdating = false;
                });
            },
            getPostImageUrl() {
                return this.post.imageUrls[`images-${this.lang}`];
            },
            resetData(post) {
                this.post = post;
                if (post.published_at) {
                    this.post.published_at = moment(post.published_at).format('YYYY-MM-DD');
                }
                this.publishStatus = post.published_at ? 'published' : 'draft';
                this.images = {
                    ms: '',
                    en: ''
                };
                this.errors = {};
            },
            getContentValidity(lang) {
                let valid = this.post.title[lang] &&
                        this.post.content[lang] &&
                        (this.post.imageUrls[`images-${lang}`] || this.images[lang]);

                return valid;
            },
            getFormValidity() {
                return this.getContentValidity('ms') && (! this.isMultiLanguage || this.getContentValidity('en'));
            }
        },
        mounted() {
            if (this.initPost && this.initPost.id) {
                this.post = this.initPost;
                if (this.initPost.published_at) {
                    this.post.published_at = moment(this.initPost.published_at).format('YYYY-MM-DD');
                }
            }
        }
    }
</script>